import { useTranslation } from 'react-i18next'
import * as z from 'zod'

export const useCreatePasswordSchema = () => {
  const { t } = useTranslation()

  const createPasswordSchema = z
    .object({
      password: z.string(),
      confirmPassword: z.string(),
    })
    .refine((values) => values.password === values.confirmPassword, {
      message: t('screens:signup.noMatch'),
      path: ['confirmPassword'],
    })

  return createPasswordSchema
}
export type ICreatePasswordSchema = z.infer<
  ReturnType<typeof useCreatePasswordSchema>
>
